import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CaretLeft, SignOut } from '@phosphor-icons/react';
import { useAuth } from '@/context/AuthContext';

export default function TopBar({ title, back = false, right = null }) {
  const nav = useNavigate();
  const { user, logout } = useAuth();
  return (
    <header
      data-testid="top-bar"
      className="sticky top-0 z-30 bg-canvas border-b-2 border-carbon px-4 py-3 flex items-center gap-3"
    >
      {back ? (
        <button
          onClick={() => nav(-1)}
          data-testid="back-btn"
          className="w-10 h-10 -ml-2 inline-flex items-center justify-center hover:bg-surface-alt"
          aria-label="Back"
        >
          <CaretLeft size={22} weight="bold" />
        </button>
      ) : (
        <div className="flex items-center gap-2">
          <div className="w-7 h-7 bg-brand-primary border-2 border-carbon" />
          <span className="font-display font-black text-lg tracking-tighter">MG</span>
        </div>
      )}
      <h1 className="flex-1 font-display font-bold tracking-tight text-lg truncate">
        {title}
      </h1>
      {right}
      {!back && user && (
        <button
          onClick={() => { logout(); nav('/login'); }}
          data-testid="logout-btn"
          className="w-10 h-10 inline-flex items-center justify-center hover:bg-surface-alt"
          aria-label="Logout"
        >
          <SignOut size={20} weight="bold" />
        </button>
      )}
    </header>
  );
}
